import type { ElementType, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const widths = {
    /* Reading width. Long-form prose, legal, blog bodies. */
    prose: 'max-w-[68ch]',
    /* Focused width. Single-column forms and flow steps. */
    narrow: 'max-w-2xl',
    /* Standard width. Most page content. */
    content: 'max-w-5xl',
    /* Wide width. Galleries and grids. */
    wide: 'max-w-7xl',
    /* The full container. 1440 with gutters. */
    full: 'max-w-none'
} as const

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
    as?: ElementType
    width?: keyof typeof widths
    children: ReactNode
}

export const Container = ({
    as: Tag = 'div',
    width = 'content',
    className,
    children,
    ...props
}: ContainerProps) => {
    return (
        <div className='container'>
            <Tag className={cn('mx-auto w-full', widths[width], className)} {...props}>
                {children}
            </Tag>
        </div>
    )
}

export default Container
